import { useEffect, useState } from 'react';

import { fetchCustomer } from '../api/customer-detail.api';
import type { CustomerDTO } from '../api/customers.api';
import type { Customer } from '../customer.types';


function mapCustomer(dto: CustomerDTO): Customer {

  return {
    id: String(dto.id),

    name: dto.full_name || '-',

    contact: dto.username
      ? `@${dto.username}`
      : String(dto.telegram_id),

    // The customer-detail contract doesn't return a status/is_blocked
    // field today, so this stays 'active' — the same default the
    // customers-list mapping already uses — rather than inventing one.
    status: 'active',

    activeServicesCount: dto.orders_count ?? 0,

    telegramId: dto.telegram_id,

    joinedAt: dto.joined_at,

    ordersCount: dto.orders_count ?? 0,

    totalPurchases: dto.total_purchases ?? 0,

    generatedCommission: dto.generated_commission ?? 0,
  };
}


export function useCustomer(id?: string) {

  const [customer, setCustomer] = useState<Customer | null>(null);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState<string | null>(null);


  useEffect(() => {

    if (!id) {
      setCustomer(null);
      setError(null);
      setLoading(false);
      return;
    }


    const customerId = id;

    let cancelled = false;

    async function load() {

      setLoading(true);
      setError(null);

      try {

        const response = await fetchCustomer(customerId);

        if (!cancelled) {
          setCustomer(mapCustomer(response.customer));
        }

      } catch {

        if (!cancelled) {
          setCustomer(null);
          setError('خطا در دریافت اطلاعات مشتری.');
        }

      } finally {

        if (!cancelled) {
          setLoading(false);
        }

      }
    }


    load();

    return () => {
      cancelled = true;
    };

  }, [id]);


  return {
    customer,
    loading,
    error,
  };
}
